import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { PhoneDetail } from 'src/app/interface/users.interface';
import { SinglePhoneFieldFormModalData } from 'src/app/interface/components/forms/single-phone-field-form.interface';

@Component({
  selector: 'single-phone-field-form-modal',
  templateUrl: './single-phone-field-form-modal.component.html',
  styleUrls: ['./single-phone-field-form-modal.component.scss']
})
export class SinglePhoneFieldFormModalComponent implements OnInit, AfterViewInit {
  // Propiedades del modal
  title: string = 'modal.edit';
  inputLabel: string = 'modal.phone';
  labelButtonCancel: string = 'buttons.cancel';
  labelButtonSave: string = 'buttons.save';
  
  // Control del teléfono
  phoneControl = new FormControl('', [Validators.required]);
  
  // Configuración del ngx-intl-tel-input
  preferredCountries = ['co', 'us', 'mx', 'pe', 'ar', 'cl', 'br'];
  separateDialCode = true;
  /** País seleccionado: usa el del teléfono inicial si existe*/
  selectedCountryISO: CountryISO = CountryISO.Colombia;
  
  // Enums para el componente
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  
  // Estado del modal
  @Input() loading: boolean = false;
  
  @Output() save = new EventEmitter<PhoneDetail>();
  @Output() cancel = new EventEmitter<void>();

  constructor(
    private matDialogRef: MatDialogRef<SinglePhoneFieldFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SinglePhoneFieldFormModalData | undefined
  ) {
    const dataSafe = (this.data ?? {}) as Partial<SinglePhoneFieldFormModalData>;
    this.title = dataSafe.title ?? this.title;
    this.inputLabel = dataSafe.inputLabel ?? this.inputLabel;
    this.labelButtonCancel = dataSafe.labelButtonCancel ?? this.labelButtonCancel;
    this.labelButtonSave = dataSafe.labelButtonSave ?? this.labelButtonSave;

    if (dataSafe.initialPhoneDetail) {
      const iso = dataSafe.initialPhoneDetail.countryCode?.toLowerCase();
      this.selectedCountryISO = (iso as CountryISO) ?? CountryISO.Colombia;
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const initial = this.data?.initialPhoneDetail;
    if (initial && this.isValidPhoneDetail(initial)) {
      setTimeout(() => {
        const valueForLibrary = this.phoneDetailToIntlTelFormat(initial);
        this.phoneControl.setValue(valueForLibrary);
      }, 0);
    }
  }

  private phoneDetailToIntlTelFormat(detail: PhoneDetail): { number: string; countryCode: string } {
    const nationalOnly = (detail.nationalNumber || '').trim().replace(/\s/g, '');
    return {
      number: nationalOnly,
      countryCode: (detail.countryCode || 'co').toLowerCase()
    };
  }

  private isValidPhoneDetail(p: PhoneDetail): boolean {
    return !!(p?.countryCode && (p?.e164Number ?? p?.nationalNumber));
  }

  onEventClose(): void {
    this.matDialogRef.close();
  }

  onEventCancel(): void {
    this.cancel.emit();
    this.matDialogRef.close();
  }

  onEventSave(): void {
    if (this.phoneControl.valid && this.phoneControl.value) {
      const phoneDetail: PhoneDetail = {
        countryCode: this.phoneControl.value.countryCode,
        dialCode: this.phoneControl.value.dialCode,
        e164Number: this.phoneControl.value.e164Number,
        nationalNumber: this.phoneControl.value.nationalNumber
      };
      
      this.save.emit(phoneDetail);
      this.matDialogRef.close(phoneDetail);
    }
  }
}
